import React, { useState, useMemo, useEffect } from 'react';
import WebhookTable from './WebhookTable';
import WebhookForm from './WebhookForm';
import ConfirmationModal from '../../../../components/shared/ConfirmationModal';
import BulkActionsBar, { BulkAction } from '../../../../components/shared/BulkActionsBar';
import { TrashIcon } from '../../../../components/icons';
import { useWebhooksPage } from '../hooks/useWebhooksPage';
import Pagination from '../../../../components/shared/Pagination';

interface OutgoingWebhooksTabProps {
    page: ReturnType<typeof useWebhooksPage>;
}

const OutgoingWebhooksTab: React.FC<OutgoingWebhooksTabProps> = ({ page }) => {
    const bulkActions: BulkAction[] = [
        { label: 'Excluir', icon: TrashIcon, onClick: () => page.setIsWebhookBulkDeleteOpen(true), variant: 'danger' }
    ];

    // Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;

    const paginatedWebhooks = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        return page.filteredWebhooks.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, page.filteredWebhooks, pageSize]);

    useEffect(() => {
        setCurrentPage(1);
    }, [page.searchTerm]);

    return (
        <>
            <WebhookTable
                webhooks={paginatedWebhooks}
                onEdit={page.openEditWebhook}
                onDelete={page.openDeleteWebhook}
                onDuplicate={page.duplicateWebhook}
                selectedIds={page.webhookSelectedIds}
                onToggleSelection={page.toggleWebhookSelection}
                onToggleAll={page.toggleAllWebhooks}
            />

            <Pagination
                currentPage={currentPage}
                totalCount={page.filteredWebhooks.length}
                pageSize={pageSize}
                onPageChange={setCurrentPage}
            />

            <WebhookForm
                isOpen={page.isWebhookFormOpen}
                onClose={() => page.setIsWebhookFormOpen(false)}
                onSave={page.saveWebhook}
                webhookToEdit={page.webhookToEdit}
            />

            <ConfirmationModal
                isOpen={page.isWebhookDeleteOpen}
                onClose={() => page.setIsWebhookDeleteOpen(false)}
                onConfirm={page.confirmDeleteWebhook}
                title="Excluir Webhook"
                message={`Excluir "${page.webhookToDelete?.name}"?`}
                confirmButtonText="Excluir"
                confirmButtonColor="red"
            />

            <ConfirmationModal
                isOpen={page.isWebhookBulkDeleteOpen}
                onClose={() => page.setIsWebhookBulkDeleteOpen(false)}
                onConfirm={page.bulkDeleteWebhooks}
                title="Excluir Webhooks"
                message={`Excluir ${page.webhookSelectedIds.size} webhook(s)?`}
                confirmButtonText="Excluir"
                confirmButtonColor="red"
            />

            <BulkActionsBar
                selectedCount={page.webhookSelectedIds.size}
                actions={bulkActions}
                onClose={page.clearWebhookSelection}
            />
        </>
    );
};

export default OutgoingWebhooksTab;
